export function assigneeDisplayName(task, assignOptions = []) {
    const staff = task?.staffuser;
    if (staff) {
        const name = `${staff.lastName || ""} ${staff.firstName || ""}`.trim();
        if (name) return name;
    }
    const opt = assignOptions.find((o) => String(o.value) === String(task?.assign_to));
    if (opt) return opt.label.split(" (")[0];
    return task?.assign_to ? "Assigned" : "Unassigned";
}

export function assigneeInitials(name) {
    const parts = String(name || "")
        .trim()
        .split(/\s+/)
        .filter(Boolean);
    if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    if (parts[0]) return parts[0].slice(0, 2).toUpperCase();
    return "?";
}

export function taskProjectName(task) {
    return task?.ListTask?.list_name || task?.list_name || null;
}

export function taskCommentCount(task) {
    const history = Array.isArray(task?.historyTasks) ? task.historyTasks : [];
    return history.filter((entry) => String(entry?.title || "") === "Comment").length;
}

export function taskAttachmentCount(task) {
    if (Array.isArray(task?.attachments)) return task.attachments.length;
    if (task?.attachment) return 1;
    return 0;
}
